// extracted by mini-css-extract-plugin
export default {"detailForm":"DetailForm_detailForm__GnBBc"};